'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name vacationSearchService
    * @description Initializes a service that interfaces with the vacation search API
    **/

    function searchVacations(requestData) {
        var defer = jQuery.Deferred();
        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(requestData),
            url: '/umbraco/api/VacationApi/Search',
            success: function (data) {
                if (data) {
                    data.forEach(function (result) {
                        if (!result.quoteRequestParams) {
                            result.quoteRequestParams = getQuoteRequestQueryStringParams(result);
                        }
                    });
                }
                defer.resolve(data);
            },
            error: function (xhr, textStatus, errorThrown) {
                defer.reject(errorThrown);
            }
        });

        return defer;
    }

    function lmdSearch(requestData) {
        var defer = jQuery.Deferred();
        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(requestData),
            url: '/umbraco/api/VacationApi/SearchLmd',
            success: function (data) {
                if (data) {
                    data.forEach(function (result) {
                        if (!result.quoteRequestParams) {
                            result.quoteRequestParams = getQuoteRequestQueryStringParams(result);
                        }
                    });
                }
                defer.resolve(data);
            },
            error: function (xhr, textStatus, errorThrown) {
                defer.reject(errorThrown);
            }
        });

        return defer;
    }

    function getVacationsByPrimaryCountry(countryId) {
        var defer = jQuery.Deferred();
        $.ajax({
            type: 'GET',
            dataType: 'JSON',
            url: '/umbraco/api/VacationApi/GetByPrimaryCountry?countryId=' + countryId,
            success: function (data) {
                if (data) {
                    data.forEach(function (result) {
                        if (!result.quoteRequestParams) {
                            result.quoteRequestParams = getQuoteRequestQueryStringParams(result);
                        }
                    });
                }
                defer.resolve(data);
            },
            error: function (xhr, textStatus, errorThrown) {
                defer.reject(errorThrown);
            }
        });

        return defer;
    }

    function getQuoteRequestQueryStringParams(result) {
        var queryStringParams = '';
        queryStringParams = '?TourSeries=' + result.tourCode;
        if (result.vacationType && result.vacationType == 1) {
            queryStringParams += '&Variant=' + result.variantKey;
        }
        if (result.departureDate) {
            queryStringParams += '&TourDepartureDate=' + moment(result.departureDate).format('YYYYMMDD');
        }

        return queryStringParams;
    }

    // Return an object exposing the public items
    return {
        search: searchVacations,
        lmdSearch: lmdSearch,
        getByPrimaryCountry: getVacationsByPrimaryCountry
    };
}())